<template>
<div>
       <p class="title font-weight-bold">Information</p>
       <v-flex>
                    <v-text-field
                      label="Kommun"
                      :readonly="ToFrom=='Show'"
                      hint="Vilken kommun bor eleven i."
                      required
                      v-model="getActivity.municipality"
                    ></v-text-field>
                      <v-text-field v-if="ToFrom!='From'"
                      :readonly="ToFrom=='Show'"
                      label="Nuvarande skola"
                      hint="Vilken skola byter eleven ifrån."
                      required
                      v-model="getActivity.school"
                    ></v-text-field>

                     <v-text-field
                      label="Namn"
                      :readonly="ToFrom=='Show'"
                      hint="Elevens fulla namn"
                      required
                      v-model="getActivity.name"
                    ></v-text-field>
                     <v-text-field
                      label="Adress"
                      :readonly="ToFrom=='Show'"
                      hint="Elevens fulla adress"
                      required
                      v-model="getActivity.adress"
                    ></v-text-field>

                  </v-flex>   

                  
       <v-flex> 
   <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      min-width="auto"
      :readonly="ToFrom=='Show'"
    >
        <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="getActivity.date"
          label="Födelsedatum"
          prepend-icon="today"
          readonly
          v-bind="attrs"
          v-on="on"
          class="ml-n2"
        ></v-text-field>
      </template>
      <v-date-picker
      
         :readonly="ToFrom=='Show'"
        v-model="getActivity.date"
        :active-picker.sync="activePicker"
        :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
        min="1950-01-01"
        @change="save"
      ></v-date-picker>
    </v-menu>
                  </v-flex>    


     <v-flex>
                    <v-text-field
                    
                      :readonly="ToFrom=='Show'"
                      label="Senaste klasslärare/mentor"
                      hint="Namn på pedagogen som mottagar eleven."
                      required
                      v-model="getActivity.lastMentor"
                    ></v-text-field>
                                        <v-text-field
                                        
                      :readonly="ToFrom=='Show'"
                      label="Kontaktuppgifter till hen"
                      hint="Telefonnummer eller mailadress"
                      required
                      v-model="getActivity.lastMentorContact"
                    ></v-text-field>
    <v-radio-group   :readonly="ToFrom=='Show'"  label="Har eleven tidigare haft behov av särskilt stöd? " v-model="getActivity.support">
      <v-radio
        label="Ja"
        value="ja"
      ></v-radio>
      <v-radio
        label="Nej"
        value="nej"
      ></v-radio>
             </v-radio-group>
             <div v-if="getActivity.hasOwnProperty('support')">
             <div v-if="getActivity.support== 'ja' ">

                     <v-text-field
                     
                      :readonly="ToFrom=='Show'"
                      label="Form av stöd"
                      hint="Vilken typ av stöd har eleven haft?"
                      required
                      v-model="getActivity.supportType"
                    ></v-text-field>
                     <v-text-field
                     
                      :readonly="ToFrom=='Show'"
                      label="Kontaktperson"
                      hint="Namn samt telefonnummer eller mailadress"
                      required
                      v-model="getActivity.supportContact"
                    ></v-text-field>
             </div>
             </div>
                  </v-flex>   

     <v-flex>

    <v-radio-group  :readonly="ToFrom=='Show'"   label="Antal tidigare skolbyten (Utöver de naturliga)" v-model="getActivity.numberChanges">
      <v-radio
        label="Ett"
        value="1"
      ></v-radio>
      <v-radio
        label="Två"
        value="2"
      ></v-radio>
       <v-radio
        label="Tre"
        value="3"
      ></v-radio>
       <v-radio
        label="Flera"
        value="4"
      ></v-radio>
             </v-radio-group>

    <v-radio-group  :readonly="ToFrom=='Show'"   label="Förstaspråk" v-model="getActivity.language">
      <v-radio
        label="Svenska"
        value="svenska"
      ></v-radio>
      <v-radio
        label="Annat"
        value="annat"
      ></v-radio>
             </v-radio-group>
             <div v-if="getActivity.hasOwnProperty('language')">
                     <v-text-field v-if="getActivity.language !='svenska'"
                     
                      hint="Förstaspråk"
                      required
                      v-model="getActivity.language"
                    ></v-text-field>
                     
             </div>
              <v-radio-group   :readonly="ToFrom=='Show'"  label="Upplevt svenska nivå:" row v-model="getActivity.swedish">
      <v-radio v-for="i in ['begränsade kunskaper','tillräckliga kunskaper','goda kunskaper','mycket goda i skrift och tal']"
      :key="i"
        :label="i"
        :value="i"
      ></v-radio>
             </v-radio-group>

   <v-radio-group  :readonly="ToFrom=='Show'"   label="Upplevt engelska nivå:" row v-model="getActivity.english">
      <v-radio v-for="i in ['begränsade kunskaper','tillräckliga kunskaper','goda kunskaper','mycket goda i skrift och tal']"
      :key="i"
        :label="i"
        :value="i"
      ></v-radio>
             </v-radio-group>

              <v-radio-group   :readonly="ToFrom=='Show'"  label="Har eleven gått i skolan i andra länder?" v-model="getActivity.country">
      <v-radio
        label="Ja"
        value="ja"
      ></v-radio>
      <v-radio
        label="Nej"
        value="nej"
      ></v-radio>
             </v-radio-group>

              <v-radio-group  :readonly="ToFrom=='Show'"  label="Finns tidigare utredningar eller kartläggningar?" v-model="getActivity.mappings">
      <v-radio
        label="Ja"
        value="ja"
      ></v-radio>
      <v-radio
        label="Nej"
        value="nej"
      ></v-radio>
             </v-radio-group>
             <div v-if="getActivity.hasOwnProperty('mappings')">
                     <v-text-field  :readonly="ToFrom=='Show'"  v-if="getActivity.mappings =='ja'"
                     
                      hint="Länk till dokumentet"
                      required
                      v-model="getActivity.mappinglink"
                    ></v-text-field>
                     
             </div>

              <v-radio-group  :readonly="ToFrom=='Show'"   label="Upplevt mående(högt är bra):" row v-model="getActivity.health">
      <v-radio v-for="i in 10"
      :key="i"
        :label="i.toString()"
        :value="i.toString()"
      ></v-radio>
             </v-radio-group>

              <v-radio-group   :readonly="ToFrom=='Show'"  label="Uppskattad timmars sömn per natt:" row v-model="getActivity.sleep">
      <v-radio v-for="i in ['Färre än tre timmar','Mellan tre och fem timmar','Mellan fem och sju','Mellan sju och tiot', 'Mellan tio och femton']"
      :key="i"
        :label="i"
        :value="i"
      ></v-radio>
             </v-radio-group>

   <v-radio-group  :readonly="ToFrom=='Show'"   label="Matvanor:" row v-model="getActivity.food">
      <v-radio v-for="i in ['Mycket regelbundet och varierad','Regelbundet och varierad','Helt ok','Sällan eller ensidigt', 'Mycket dålig']"
      :key="i"
        :label="i"
        :value="i"
      ></v-radio>
             </v-radio-group>
              <v-radio-group   :readonly="ToFrom=='Show'"  label="Motion (allt från promenader till elitidrott räknas) i timmar per vecka:" row v-model="getActivity.training">

      <v-radio v-for="i in ['Mindre än en','Mellan en och tre','Mellan tre och fem','Mellan fem och sju','Över sju timmar']"
      :key="i"
        :label="i"
        :value="i"
      ></v-radio>
             </v-radio-group>

             <v-text-field  :readonly="ToFrom=='Show'" 
                      label="Allergier "
                      hint="Har eleven några allergier"
                      required
                      v-model="getActivity.allergies"
                    ></v-text-field>
                   
                  </v-flex> 

             <p class="title font-weight-bold">Detta kan vara bra att veta om {{getActivity.name}}:</p>
      
       <v-textarea  :readonly="ToFrom=='Show'" 
          solo
          v-model="getActivity.infoSchool"
          name="input-7-4"
          label="Information som är bra att veta rörande eleven"
        ></v-textarea>  

           <v-textarea  :readonly="ToFrom=='Show'" 
          solo
          v-model="getActivity.other"
          name="input-7-4"
          label="Övrigt"
        ></v-textarea>  
        <div v-if="ToFrom!='Show'">
         <v-btn dark color="green ligthen-1" v-if="ToFrom=='From'" @click="
showSuccessSnackbar('Informationen är inskickad.Bra jobbat.');getActivity.school=school.name; updatePlan(getActivity);">
              Skicka in
            </v-btn> 
            <v-btn dark color="green ligthen-1"  v-else @click="
showSuccessSnackbar('Informationen är inskickad. Återigen, tack för gott samarbete,'+school.name+'.'); updatePlan(getActivity);emitToParent();">
              Skicka in
            </v-btn> 
        </div>
            <!-- updatePlan(getActivity); -->

        </div>


</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
  },
 props: {
   ToFrom: String,
   getActivity: Object,
  },
  data: () => ({    
      activePicker: null,
      
      menu: false,

  }),
  computed: {
   
    
    ...mapGetters('schools', ['school']),
  },
  watch: {
      menu (val) {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
      },
    },
    methods: {

 emitToParent (event) {
      this.$emit('childToParent', false)
    },

      save (date) {
        this.$refs.menu.save(date)
      },
    ...mapActions('schools', ['initschool']),
      ...mapActions('ehtmembers', ['GetStartEnd']),

    ...mapActions(['showSuccessSnackbar']),
    ...mapActions("ehtmembers", ["updatePlan"]),

  },
  created () {
   
// this.GetStartEnd(this.nurseId);
   
  },
}
</script>
<style>
.loader{
  margin-top: 20vh;
}



</style>
